export default (initialNumber) => {
  if (!initialNumber) { return ''; }

  const digits = initialNumber.toString().length;

  if (digits >= 0 && digits <= 3) {
    return `${initialNumber} bytes`;
  }

  if (digits > 3 && digits <= 6) {
    return `${Math.round(initialNumber / 1000)} KB`;
  }

  if (digits > 6 && digits <= 9) {
    return `${Math.round(initialNumber / 1000000)} MB`;
  }

  return `${Math.round(initialNumber / 10000000) / 100} GB`;
};
